// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".document-wrapper #spreadsheet .k-spreadsheet-cell {\n  opacity: 1;\n}\n", "",{"version":3,"sources":["webpack://src/modules/documents/components/DocumentExcel.less"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ","sourcesContent":[".document-wrapper #spreadsheet .k-spreadsheet-cell {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
